import { http } from '@/core/api/';

const apiUrl = 'api/academicyears';
export default {
  async getCurrentAcademicYear() {
    try {
      const { data } = await http.get(`${apiUrl}/current`);
      if (data) {
        return data;
      }
      return null;
    } catch {
      return null;
    }
  },
  async getReferralServiceAcademicYears() {
    try {
      const { data } = await http.get(
        `${apiUrl}/getreferralserviceacademicyears`
      );
      if (data) {
        const mappedResults = data.map(function(element) {
          return {
            id: element.id,
            value: element.year,
            name: element.description,
            isSelected: false,
          };
        });

        return mappedResults;
      }
      return [];
    } catch {
      return [];
    }
  },
  async getReferralAppointment() {
    return await http.get(`${apiUrl}/referralappointment`);
  },
  async getAvailableMonths(academicYearId) {
    try {
      const { data } = await http.get(`${apiUrl}/${academicYearId}/months`);
      if (data) {
        return data;
      }
      return [];
    } catch {
      return [];
    }
  },
  //Request Service Monitoring
  async getAcademicYearsAnswerRequest() {
    try {
      const { data } = await http.get(`${apiUrl}/academicYearsanswerrequest`);
      if (data) {
        return data;
      }
      return null;
    } catch {
      return null;
    }
  },
  //Student-Compu-History
  async getPlacementCommitteeAdemicYear(studentSieId) {
    try {
      const { data } = await http.get(
        `${apiUrl}/placementcommitteeademicyear/${studentSieId}`
      );
      if (data) {
        return data;
      }
      return null;
    } catch {
      return null;
    }
  },
  async getAcademicYears() {
    return http.get('/api/academicyears');
  },
  async getAcademicYearsToCurrent() {
    return http.get('/api/academicyears/getacademicyearstocurrentyear');
  },
};

export const getStudentEvaluationAcademicYears = (studentSieId) =>
  http.get(`${apiUrl}/getacademicyearsforstudentevaluation/${studentSieId}`);
